import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import i18n from "../../../../constants/i18n";
import {
  CURRENT_RECEIPT_MONTH_HEADERS,
  SUPERVISOR_COMPENSATION_INPUT_DATA_HEADERS,
  PREVIOUS_RECEIPT_MONTH_HEADERS
} from "../../../../constants/table-custom-headers/Supervisor";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { reduce } from "et3-type-guards";
import ET3Div from "../../../../core/et3-div";
import getSupervisorReceiptStore from "../../../../stores/supervisor-store/supervisor-receipt-compensation-store";
import {
  currentMonthSupervisorArray,
  dataInputArray
} from "../../../../helpers/et3-receipt-compensation-and-calculation/supervisor-receipt-helpers";

const SupervisorReceiptCompensationData = withLiteObserverAndTheme(() => {
  const currentMonthSupervisorReceipt = reduce(
    () => currentMonthSupervisorArray(),
    []
  );
  const supervisorCompensationInputData = reduce(() => dataInputArray(), []);
  const supervisorCompensationPreviousMonths = reduce(
    () => getSupervisorReceiptStore().adminFinalReceipts.get(),
    []
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={1500}
      height={300}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <Et3Table
        columns={CURRENT_RECEIPT_MONTH_HEADERS}
        rows={currentMonthSupervisorReceipt}
        title={i18n.get("CURRENT_RECEIPT_MONTH")}
        shouldBeFlagged={false}
        titleKey={"CURRENT_RECEIPT_MONTH"}
      />
      <Et3Margin top={30} left={0} right={0} bottom={0} />
      <Et3Table
        columns={SUPERVISOR_COMPENSATION_INPUT_DATA_HEADERS}
        rows={supervisorCompensationInputData}
        title={i18n.get("SUPERVISOR_RECEIPT_COMPENSATION_DATA_INPUT")}
        shouldBeFlagged={false}
        titleKey={"DATA_INPUT"}
      />
      <Et3Margin top={30} left={0} right={0} bottom={0} />
      <Et3Table
        columns={PREVIOUS_RECEIPT_MONTH_HEADERS}
        rows={supervisorCompensationPreviousMonths}
        title={i18n.get("PREVIOUS_RECEIPT_MONTH")}
        titleKey={"PREVIOUS_RECEIPTS_MONTHS"}
        shouldBeFlagged={false}
      />
    </ET3Div>
  );
});

export default SupervisorReceiptCompensationData;
